module.exports = __webpack_public_path__ + "img/check_circle.01a675cb.svg";